// The first-launch flag of « Médard vous accueille » — the phone's welcome
// veil is shown ONCE per guest (localStorage, survives sessions). It lives
// here, in the trunk, because two readers need it: the veil itself
// (components/mobile/MedardAccueil, inside the « experience » chunk) and the
// route fallback in App.js, which paints the veil's ground WHILE that chunk
// downloads (audit 10/09 bis) — and must not import the chunk to know it.
export const ACCUEIL_SEEN_KEY = 'medard_accueil_seen_v1';

// localStorage can throw (Safari private mode). If it is unreadable we treat
// the film as SEEN — never risk replaying the welcome on every launch.
export const accueilAlreadySeen = () => {
    try {
        return window.localStorage.getItem(ACCUEIL_SEEN_KEY) === '1';
    } catch {
        return true;
    }
};
